import { h } from 'preact'
import ArticleIcon from './assets/articleIcon.js'
import Title from './Title'
import ButtonControlSelector, {SelectorItem} from "../button-control-selector";

interface Props {
  draftSaved: boolean
  hasUnsavedChanges: boolean
  title: string
  error: string
  meta: {
    is_scheduled: boolean
  } | null
  onTitleChanged: (title: string) => void
  onPublish: () => void
  onSaveAsDraft: () => void
  onDeleteHandler: ()=> void
  onSchedulePublish: () => void
}

const Header = ({
    draftSaved,
    hasUnsavedChanges,
    title,
    error,
    meta,
    onTitleChanged,
    onPublish,
    onSaveAsDraft,
    onDeleteHandler,
    onSchedulePublish
  }: Props) => {
  const draftButtonText = !draftSaved ? 'Save as draft' : hasUnsavedChanges ? 'Save changes' : 'All saved'
  const isDraftButtonDisabled = draftSaved && !hasUnsavedChanges

  const getSelectorItems = (): Array<SelectorItem> => {
    const actions: Array<SelectorItem> = [
      {
        isPrincipal: true,
        title: draftButtonText,
        onClick: onSaveAsDraft,
        disabled: isDraftButtonDisabled,
        class: `qa-save-draft${draftSaved ? ' article-creator__action-buttons-btn-save-changes' : ''}`
      },
      {
        title: 'Publish Now',
        onClick: onPublish,
        class: 'qa-publish'
      }
    ]

    if(!meta?.is_scheduled) {
      actions.push({
        title: 'Schedule publishing',
        onClick: onSchedulePublish,
        class: 'qa-schedule-publish'
      })
    }

    if(draftSaved) {
      actions.push({
        title: 'Delete',
        onClick: onDeleteHandler,
        variant: 'danger',
        class: 'qa-delete-list-item'
      })
    }

    return actions
  }

  return (
    <div class='control-header'>
      <div class='article-creator__article-icon-circle'>
        <ArticleIcon />
      </div>
      <Title
        title={title}
        error={error}
        meta={meta}
        onTitleChanged={(value: string) => onTitleChanged(value)}
        draftSaved={draftSaved}
      />
      <div class='article-creator__action-buttons'>
        <ButtonControlSelector items={getSelectorItems()} />
      </div>
    </div>
  )
}

export default Header
